type Cc = (...a: (undefined | null | string | boolean)[]) => string;

// small clsx replacement, taken from here:
// https://dev.to/gugaguichard/replace-clsx-classnames-or-classcat-with-your-own-little-helper-3bf

export const cc: Cc = (...args) =>
    args
        .flat()
        .filter((x) => x !== null && x !== undefined && typeof x !== "boolean")
        .join(" ");
